import { render, staticRenderFns } from "./TifMapasOptions.vue?vue&type=template&id=2357b820"
import script from "./TifMapasOptions.vue?vue&type=script&lang=js"
export * from "./TifMapasOptions.vue?vue&type=script&lang=js"
import style0 from "./TifMapasOptions.vue?vue&type=style&index=0&id=2357b820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports